<template>
    <div>


        <div class="cc"  style="margin: auto; width: 690px;">
            <h1>
                {{translation["STR_TEST_FROM"]}} {{ data.time | humanTime }}
            </h1>
                <table border=0 cellspacing=0>
                <thead>
                    <th width="140">{{ translation.STR_POSITION }}</th>
                    <th width="250">{{ translation.STR_BARCODE }}</th>
                    <th>{{ translation.STR_CT_VALUE }}</th>
                    <th>{{ translation.STR_HUMAN_CONTROL }}</th>
                    <th>{{ translation.STR_TEST_RESULT }}</th>
                </thead>
                <tr v-for="w in resultTable">
                    <td>{{ w["well"]}}</td>
                    <td>{{ w["sample"] }}</td>
                    <td><span v-if="w['positive']">{{ w["ct"] }}</span><span v-else>-</span></td>
                    
                    <td>
                        <span v-if="w['cy5'].positive">{{ translation.STR_VALID }}</span>
                        <span v-if="!w['cy5'].positive">{{ translation.STR_INVALID }}</span>
                    </td>
                    <td :class="{ 'positiv' : w['positive'] }">
                        <span v-if="w['positive']">{{ translation.STR_POSITIVE }}</span>
                        <span v-if="!w['positive']">{{ translation.STR_NEGATIVE }}</span>
                    </td>
                </tr>
            </table>
        </div>

    </div>
</template>
<script>
export default ({
    props: [ 'translation', 'token' ],
    filters: {
        humanTime(unix_timestamp) {
            var i = new Date(unix_timestamp);
            return i.toLocaleString("de-DE", {timeZoneName: "short"})
        }
    },
    computed: {
        resultTable() {
            var filtered_probes = this.data.wells.filter(e => e.target !== "CY5");
            var control_probes = this.data.wells.filter(e => e.target == "CY5");
            control_probes.forEach((pr) => {
                var i = filtered_probes.find(e => e.well == pr.well);
                if(i) {
                    i.cy5 = pr;
                }
            })
            return filtered_probes;
        }
    },    
    mounted() {
        this.data = this.$route.params.data;
        console.log(this.$router.params);
    },
    data() {
        return {
            data: null,
        }
    }
})
</script>
<style scoped>
h1 {
    color: var(--primary-color);
}
table td {
    padding: 10px;
}

tr:nth-child(odd) {
    background-color: rgba(240,240,240,0.9);
}

.positiv {
    background-color: pink;
    font-weight: bold;
}

.btns {
    display: flex;
}
.submit {
    padding: 15px;
    margin-top: 15px;
    background-color: var(--primary-color);
    color: var(--secondary-color);
    border: 1px solid var(--primary-color);
    cursor: pointer;
    margin-right: 10px;
}
</style>
